module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "autoNumberCues",
    attrs: {
      "md-open-from": "#autoNumberCues",
      "md-close-to": "#autoNumberCues"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "14px",
      "padding-bottom": "0px"
    }
  }, [_c('md-dialog-content', [_c('p', [_vm._v("Auto Number Selected Cues")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "auto-number-fields"
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "auto-number-start"
    }
  }, [_vm._v("Starting Number*")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "auto-number-start",
      "type": "number",
      "required": ""
    },
    on: {
      "input": _vm.validate
    },
    model: {
      value: (_vm.startingNumber),
      callback: function($$v) {
        _vm.startingNumber = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "startingNumber"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "auto-number-interval"
    }
  }, [_vm._v("Interval*")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "auto-number-interval",
      "type": "number",
      "required": ""
    },
    on: {
      "input": _vm.validate
    },
    model: {
      value: (_vm.interval),
      callback: function($$v) {
        _vm.interval = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "interval"
    }
  })], 1)], 1), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    staticStyle: {
      "margin-bottom": "25px"
    },
    attrs: {
      "disabled": _vm.btnDisabled
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("AUTO NUMBER")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d7cf593","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/auto-number-cues.vue
// module id = 1258
// module chunks = 21